"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _Operator = _interopRequireDefault(require("../Operator"));
var _Value = _interopRequireDefault(require("../Value"));
var _operators = _interopRequireDefault(require("../operators.js"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("./style.css"));
var _CccisdFieldWrapper = _interopRequireDefault(require("../../CccisdFieldWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Condition = function Condition(props) {
  var path = props.path,
    condition = props.condition,
    DataConnectorsPicker = props.DataConnectorsPicker,
    params = props.params;
  var getOperatorDefinition = function getOperatorDefinition() {
    if (!condition.dataConnector || !condition.operator) {
      return null;
    }
    return (0, _find2["default"])(_operators["default"][condition.dataConnector.type], {
      code: condition.operator
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'alert alert-info ' + _style["default"].conditionWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].lastRow
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "".concat(path, ".dataConnector"),
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react["default"].createElement(_CccisdFieldWrapper["default"], {
        field: field,
        form: form,
        showErrorImmediately: true
      }, field.value ? field.value.title || 'picked' : 'none', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: "modal",
        title: "Pick ".concat(params.connectorName),
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: _style["default"].button + ' btn btn-xs btn-default',
          title: "Link ".concat(params.connectorName)
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "glyphicon glyphicon-link"
        })),
        size: "large",
        render: function render(_ref2) {
          var closeModal = _ref2.closeModal;
          return /*#__PURE__*/_react["default"].createElement(DataConnectorsPicker, {
            value: field.value,
            onChange: function onChange(value) {
              return form.setFieldValue(field.name, value);
            },
            closeModal: closeModal
          });
        }
      }), field.value && /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-default",
        title: "Delete ".concat(params.connectorName),
        style: {
          marginLeft: '.2em'
        },
        onClick: function onClick() {
          return form.setFieldValue(field.name, null);
        }
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-remove text-danger"
      })));
    }
  })), condition.dataConnector && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].condition
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].lastRow
  }, /*#__PURE__*/_react["default"].createElement(_Operator["default"], {
    name: "".concat(path, ".operator"),
    dataConnector: condition.dataConnector
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].lastRow
  }, /*#__PURE__*/_react["default"].createElement(_Value["default"], {
    name: "".concat(path, ".value"),
    operator: getOperatorDefinition()
  }))));
};
Condition.propTypes = {
  path: _propTypes["default"].string,
  condition: _propTypes["default"].object,
  DataConnectorsPicker: _propTypes["default"].func,
  params: _propTypes["default"].object
};
var _default = exports["default"] = Condition;